import { SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement, ReactNode } from 'react';

import { DynamicSchemaDefinitionSelectMultiple } from '../../../../../generated/graphql';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionSelectMultiple, 'choices' | 'label'>;
  value: SelectMultipleValue;
  className?: string;
}

const AsMultipleSelection = ({ field, value, className }: Props & ClassAttributes<HTMLElement>) => {
  const items = value
    .reduce((whole, item) => {
      const correspondingChoice = field.choices.find((choice) => choice.key === item);

      if (correspondingChoice) {
        return [...whole, ', ', <span key={item}>{correspondingChoice.label}</span>];
      }

      return whole;
    }, [] as ReactNode[])
    .slice(1);

  return (
    <Base field={field} className={className}>
      <Typography variant="body2">{items}</Typography>
    </Base>
  );
};

export default AsMultipleSelection;
